import { useEffect } from "react";
import {
  hideAlertMessage,
  showAlertMessage,
} from "../../store/alert/alert-slice";
import { useAppDispatch, useAppSelector } from "../../store/store";

export const useAppAlert = (props: any = null) => {
  const alert = useAppSelector((state) => state.alert);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (alert.showAlert) {
      const alertTimer = setTimeout(() => {
        dispatch(hideAlertMessage());
      }, 2600);
      return () => clearTimeout(alertTimer);
    }
  }, [alert.showAlert, dispatch]);

  const closeAlert = () => dispatch(hideAlertMessage());

  const openAlert = (
    alertMessage: any,
    alertType: any = "alert-error-message"
  ) => {
    dispatch(
      showAlertMessage({
        alertMessage,
        alertType,
      } as any)
    );
  };

  return { openAlert, alert, closeAlert };
};
